import React from "react"

import Highlight from 'react-highlight.js';

import './code-sample.css'

const CodeSample = () => (							
        <div className="code-demo-container">
            <link rel="stylesheet" href='https://highlightjs.org/static/demo/styles/railscasts.css'/>
            <div className="code-sample-window-bar">	
            </div>
            <div className="code-sample-window-content">
                <Highlight language={'javascript'}>
                    <pre><code className="javascript hljs d-block">
{`
const maesh = Maesh();

maesh.create({ 
    api_key : 'YOUR_API_KEY', 
    dom_element_id : ​'maesh'​, 
    currency: ​'SGD'​, 
    amount: ​21700​, 
    gotoUrl: ​'https://merchant.com/success'​, 
    referenceCode: ​'ABCDEFGH' 
})
`}
                    </code></pre>	
                </Highlight>
            </div>
        </div>
)

export default CodeSample;